import { createContext, useContext, useState, useEffect } from "react";
import { getJwtToken } from "./api";
import { rootUrl } from "./global";

export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export default function AuthProvider({ children }) {
    const [isAuthenticated, setAuthentication] = useState(false);
    const [userEmail, setUserEmail] = useState(null);
    const [userRoles, setUserRoles] = useState(null);
    const [userZone, setUserZone] = useState(null);

    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        const storedRoles = localStorage.getItem("roles");
        const storedZone = localStorage.getItem("zone");

        console.log("Restoring from localStorage:");
        console.log("storedRoles:", storedRoles); // ADD THIS

        if (storedToken) {
            setAuthentication(true);
            setUserRoles(storedRoles);
            setUserZone(storedZone);

            rootUrl.interceptors.request.use((config) => {
                config.headers.Authorization = storedToken;
                config.headers.Accept = 'application/json';
                return config;
            });
        }
    }, []);

    // useEffect(() => {
    //     const storedToken = localStorage.getItem("token");
    //     console.log("Is storedToken:", storedToken);
    //     if (storedToken) {
    //         setAuthentication(true);
    //         setToken(storedToken);
    //         // Set headers for subsequent requests
    //         rootUrl.interceptors.request.use((config) => {
    //             config.headers.Authorization = storedToken;
    //             config.headers.Accept = 'application/json';
    //             return config;
    //         });
    //     }
    // }, []);

    // // Log isAuthenticated whenever it changes
    // useEffect(() => {
    //     console.log("Is Authenticated after loading:", isAuthenticated);
    // }, [isAuthenticated]);

    async function login(email, password) {
        try {
            const res = await getJwtToken(email, password);
            console.log("res ", res);
            if (res.status === 200) {
                const token = "Bearer " + res.data.token;
                const roles = res.data.roles;
                const zone = res.data.zone;

                setAuthentication(true); // This will not immediately update isAuthenticated
                localStorage.setItem("token", token); // Store the token in localStorage
                localStorage.setItem("roles", roles); // Store the roles in localstorage
                localStorage.setItem("zone", zone.toLowerCase());

                setUserEmail(email);
                setUserRoles(roles);
                setUserZone(zone.toLowerCase());
                // Set headers for subsequent requests
                rootUrl.interceptors.request.use((config) => {
                    if (!config.url.includes("/login")) {
                        const storedToken = localStorage.getItem("token");
                        if (storedToken) {
                            config.headers.Authorization = storedToken;
                        }
                    }
                    config.headers.Accept = 'application/json';
                    return config;
                });
                return true;
            } else {
                logout();
                return false;
            }
        } catch (error) {
            console.error("Error during login:", error);
            logout();
            return false;
        }
    }

    function logout() {
        setAuthentication(false);
        setUserEmail(null);
        setUserRoles(null);
        setUserZone(null);
        localStorage.removeItem("token");
        localStorage.removeItem("roles"); // Assuming you are storing roles as well
        localStorage.removeItem("zone")

        // Clear all cookies
        document.cookie.split(';').forEach((c) => {
            document.cookie = c.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });

        // Reset axios interceptors if they are set
        rootUrl.interceptors.request.handlers = [];
    }

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, userEmail, userRoles, userZone }}>
            {children}
        </AuthContext.Provider>
    );
}
